module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-4-svgrepo-com.01ba9842.svg";